// extracted by mini-css-extract-plugin
module.exports = {"addressRowLabel":"AddressRow_addressRowLabel__3E-ae","addressWrap":"AddressRow_addressWrap__3MRH0","address":"AddressRow_address__34lRM","listIcon":"AddressRow_listIcon__3N_3y"};